import { ContentRender } from '../ContentRender/ContentRender';
import CategoryContent from '../Util/CategoryContent';
import React from 'react';

const ProductContent = ({ data }) => {
  const id = parseInt(data.stringValue, 10);
  if (isNaN(id)) return false;
  console.log(id);
  return (
    <CategoryContent catId={id}>
      {(category) => (
        <>
          <ContentRender data={category?.data} />
        </>
      )}
    </CategoryContent>
  );
};

export default ProductContent;
